import React from "react";
import { useSearchParams } from "react-router-dom";
import AppHandoff from "../components/AppHandoff";
import Growie from "../components/Growie";

/**
 * Where an email button lands when the destination is the app, not the web.
 *
 * On Android a verified app link already opens the app straight from the mail,
 * so this page is rarely seen there. On iOS, and on any phone without the app
 * installed, it is the difference between "the button did nothing useful" and
 * one tap to the right store.
 */
export default function OpenInApp() {
  const [params] = useSearchParams();

  // Only in-app paths: an open redirect would turn our own domain into a way
  // to bounce someone anywhere.
  const raw = params.get("to") || "/app";
  const to = raw.startsWith("/") && !raw.startsWith("//") ? raw : "/app";

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-slate-900">
      <div className="w-full max-w-md text-center">
        <Growie pose="wave" className="w-24 h-24 mx-auto" title="Growie, mascota iGROWth" />
        <h1 className="mt-2 mb-6 text-2xl font-bold text-white">
          <span className="text-emerald-400">i</span>GROWth
        </h1>
        <AppHandoff
          path={to}
          attempt
          title="Deschidem aplicația..."
          subtitle="Dacă nu se deschide singură, instaleaz-o de mai jos — durează un minut."
        />
      </div>
    </div>
  );
}
